import dayjs from 'dayjs';

import { BookingWaitInfo, BookingWaitList } from '../store/types';

export const getActiveWaitingTimes = (waitingList: BookingWaitList) => {
  const filteredTimeList: string[] = [];
  waitingList.forEach((waitingInfo, waitingIndex) => {
    if (waitingInfo.entries.length !== 0) {
      filteredTimeList.push(waitingInfo.time);
      if ((waitingList[waitingIndex + 1]?.entries?.length ?? 0) === 0) {
        filteredTimeList.push(dayjs(waitingInfo.time).add(30, 'minute').format('YYYY-MM-DDTHH:mm:ss'));
      }
    }
  });
  return (filteredTimeList);
};

export const getActiveWaitersList = (waitingList: BookingWaitList) => {
  const filteredTimeList: Record<number, BookingWaitInfo> = {};
  waitingList.forEach((waitingInfo) => {
    waitingInfo.entries.forEach((entrie) => {
      filteredTimeList[entrie.id] = entrie;
    });
  });
  return (Object.values(filteredTimeList));
};
